<template>
  <div>
    <login-form />
  </div>
</template>

<script>
import LoginForm from '@/components/Shared/LoginForm'

export default {
  components: {
    LoginForm
  }
}
</script>
